import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {Ease, TimelineLite, TimelineMax} from "gsap";
import {DisplayObject} from "pixi.js";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {TOAGameEvent} from "../../events/TOAGameEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";


export interface IShakeConfig {
    x: number;
    y: number;
    obj: DisplayObject;
    duration: number;
    Intensity?: number;
    hertz: number;
    ease?: Ease;
    angle?: number;
    reverseEase?: boolean;
    repeat?: number
    positionCb?: () => PIXI.Point;
}

export class TOAShakeEffect {
    private _stopShake: boolean = false;
    private _tl: TimelineLite;
    private _shakeContainerList: PIXI.Container[] = [];

    constructor() {
        this.addEventListener();
        this._shakeContainerList.push(
            StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.SYMBOLS.name),
            StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.REELS_FRAME.name),
            StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.REEL_DIVIDERS.name),
            //StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.STONE_PRESSER.name),
            StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.OVERLAY_SPINES.name),
        );
    }

    public Shake(config: IShakeConfig): TimelineMax {
        let startPosY: number = config.obj.y;
        let startPosX: number = config.obj.x;
        let t: boolean = true;
        const tl: TimelineMax = new TimelineMax({
            repeat: config.repeat,
            onStart: () => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete: () => {
                if (config.obj.transform && config.obj.position) {
                    config.obj.y = startPosY;
                    config.obj.x = startPosX;
                    //config.obj.angle = 0;
                } else {
                    //Logger.logDev("transform or Position undefined ", config.obj);
                }
                if (this._stopShake) {
                    return;
                }
                if (config.positionCb && config.obj) {
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                }
            },
            onUpdate: () => {
                if (this._stopShake) {
                    return;
                }
                //config.obj.angle = 0;
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = config.ease ? config.ease.getRatio(nt) as number : nt;
                et = 0.5;
                if (t) {
                    t = false;
                    return;
                }
                if (config.positionCb && config.obj) {
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }
                if (config.reverseEase)
                    et = 1 - et;
                if (config.Intensity) {
                    // if (config.angle != 0)
                    //     config.angle && (config.obj.angle = (Math.cos(lt * config.hertz) * et) * config.angle);
                    if (config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt * config.hertz) * (config.Intensity * et) * config.y;

                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * (config.Intensity * et)) * config.x;
                } else {
                    if (config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt * config.hertz) * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * et) * config.x;
                }
            }
        });
        !this._stopShake && tl.to(this, config.duration, {});
        return tl;
    }

    private addEventListener(): void {
        EventHandler.addEventListener(this, TOAGameEvent.START_SHAKE, (event: GameEvent) => this.startShake(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.STOP_SHAKE, () => this.stopShake());
    }

    /**
     * to stop shake on skip
     */
    private stopShake(): void {
        this._stopShake = true;
        if (this._tl?.isActive()) {
            this._tl?.progress(100).pause().kill();
        }
    }

    // protected parseFeatureGameData(data: TombOfAkhenatenParsedGameData): void {
    //     this._gameData = data;
    //     TOAShakeEffect._symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(TombOfAkhenatenGameConfig.instance.REELS_NUM, () => {
    //         return ArrayHelper.initArrayWithValues<boolean>(TombOfAkhenatenGameConfig.instance.SYMBOLS_NUM_IN_REEL[2], () => false)
    //     });
    // }
    //
    // protected hasWin(): boolean {
    //     return this._gameData!.isBigWin ? true : false;
    // }

    public abort(): void {
        this.stopShake()
        //super.abort();
    }

    private startShake(isAnticipation: boolean = false) {
        this._stopShake = false;
        if (this._tl?.isActive()) {
            this._tl?.pause().kill();
        }
        this._tl = new TimelineLite();
        this._shakeContainerList.forEach((container, index) => {
            this._tl.add(
                this.Shake({
                    x: 0.02,
                    y: 0.02,
                    obj: container,
                    repeat: 0,
                    duration: isAnticipation ? 50 : 1,
                    Intensity: 50,
                    hertz: 200,
                    //angle: 1
                    // positionCb: () => new PIXI.Point(0, 0),
                }).play(), 0);
        })
    }
}